<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRBodyCam1 }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PRBodyCam2 }}
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRBodyCam3 }}</label>
                <input type="text" class="form-control" v-model="store.formData.Bodycam.CaseNumber" @@blur="updateCaseNumber" />
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRBodyCam4 }}<span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Bodycam.IncidentDate" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy"></VueDatePicker>
                <!--<bootstrap-datetime-picker :options="dtPickerOptions" v-model="store.formData.Bodycam.IncidentDate" @@input="validatePage('Bodycam', 'incidentDate')"></bootstrap-datetime-picker>-->
                <div v-if="store.errors.Bodycam.IncidentDate" class="error">{{ store.lexicon[store.culture].PRBodyCam5 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRBodyCam5a }} <span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Bodycam.IncidentTime" time-picker auto-apply model-type="format" format="hh:mm aa" :is-24="false"></VueDatePicker>
                <!--<input type="text" class="form-control" v-model="store.formData.Bodycam.IncidentTime" @@blur="updateTimeOfIncident" />-->
                <div v-if="store.errors.Bodycam.IncidentTime" class="error">{{ store.lexicon[store.culture].PTCCTV8 }}</div>
            </div>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRBodyCam7 }} <span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Bodycam.IncidentDescription" @input="validatePage('Bodycam', 'incidentDescription')"></textarea>
            <div v-if="store.errors.Bodycam.IncidentDescription" class="error">{{ store.lexicon[store.culture].PRBodyCam8 }}</div>
        </div>

        <div class="mb-3">
            <strong>{{ store.lexicon[store.culture].PRBodyCam9 }}</strong>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRBodyCam10 }} <span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Bodycam.Reason" @input="validatePage('Bodycam', 'reason')"></textarea>
            <div v-if="store.errors.Bodycam.Reason" class="error">{{ store.lexicon[store.culture].PRBodyCam11 }}</div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>